
export const BorderlessGraph = ( { children, height, width, margin }) => (
  <svg  preserveAspectRatio="xMidYMid meet" viewBox={`0 0 ${width} ${height}`} className="svg-content">
    <g transform={`translate(${margin.left},${margin.top})`}>
      {children}
    </g>
  </svg>
);
